// extracted by mini-css-extract-plugin
export var editButton = "_nz-0";